var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"options-item",class:{'parent-without-footer': !_vm.parentHasFooter}},[_c('div',{staticClass:"item-text"},[_vm._t("description")],2),(_vm.$slots.actions)?_c('div',{staticClass:"item-actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }